import React from "react";
import { Select } from "antd";

interface Option {
  label: string;
  value: string | number;
}

interface CustomSelectProps {
  value: string | number;
  onChange: (value: string | number) => void;
  options: Option[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
  showSearch?: boolean;
  allowClear?: boolean;
  loading?: boolean;
  mode?: "multiple" | "tags";
  maxTagCount?: number;
  style?: React.CSSProperties;
  dropdownStyle?: React.CSSProperties;
  filterOption?: (input: string, option?: Option) => boolean;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  value,
  onChange,
  options,
  placeholder = "Select option",
  className = "",
  disabled = false,
  size = "middle",
  showSearch = true,
  allowClear = true,
  loading = false,
  mode,
  maxTagCount,
  style,
  dropdownStyle,
  filterOption,
}) => {
  const defaultFilterOption = (input: string, option?: Option) => {
    if (!option) return false;
    return option.label.toLowerCase().includes(input.toLowerCase());
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full ${className}`}
      disabled={disabled}
      size={size}
      showSearch={showSearch}
      allowClear={allowClear}
      loading={loading}
      mode={mode}
      maxTagCount={maxTagCount}
      filterOption={filterOption || defaultFilterOption}
      options={options}
      style={{
        borderRadius: "8px",
        borderColor: "#f59e0b", // amber-500
        ...style,
      }}
      dropdownStyle={{
        borderRadius: "8px",
        ...dropdownStyle,
      }}
    />
  );
};

export default CustomSelect;
